/* ============================================================
   Selected Match Maker — sw-matchmaker.js
   Vanilla ES2019 IIFE, geen dependencies. Statisch asset:
   alle dynamiek komt uit data-attributen op #sw-mm plus de
   JSON-blokken #swmm-strings en #swmm-config-fallback.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('sw-mm');
  if (!root) return;

  /* ---------- omgeving ---------- */
  var API = (root.getAttribute('data-api-base') || '').replace(/\/+$/, '');
  var LANG = (root.getAttribute('data-lang') || 'nl').toLowerCase();
  var COUNTRY = root.getAttribute('data-country') || '';
  var EMAIL_ON = root.getAttribute('data-email') === '1';
  var ROOT_PATH = root.getAttribute('data-root') || '';

  var heroEl = document.getElementById('swmm-hero');
  var introEl = document.getElementById('swmm-intro');
  var appEl = document.getElementById('swmm-app');
  if (!appEl) return;

  function readJSON(id) {
    var node = document.getElementById(id);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  var STRINGS = readJSON('swmm-strings') || {};
  var UI = STRINGS.ui || {};
  var SLBL = STRINGS.labels || {};
  var FALLBACK = readJSON('swmm-config-fallback');

  /* ---------- state ---------- */
  var STEP_KEYS = { room: 'r', wetroom: 'w', style: 's', type: 't', panorama: 'p', theme: 'th', material: 'm', color: 'c', budget: 'b', finish: 'v' };
  var KEY_STEPS = {};
  Object.keys(STEP_KEYS).forEach(function (k) { KEY_STEPS[STEP_KEYS[k]] = k; });

  var cfg = null;
  var state = {
    answers: {},
    idx: -1,
    inQuiz: false,
    results: null,
    sessionId: 'mm-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8)
  };

  /* ---------- i18n ---------- */
  function t(key, repl) {
    var s = UI[key];
    if (s == null) s = key;
    if (repl) {
      Object.keys(repl).forEach(function (k) {
        s = s.split('{' + k + '}').join(String(repl[k]));
      });
    }
    return s;
  }
  function labelLookup(k) {
    if (SLBL[k] != null) return SLBL[k];
    if (cfg && cfg.labels && cfg.labels[k] != null) return cfg.labels[k];
    if (FALLBACK && FALLBACK.labels && FALLBACK.labels[k] != null) return FALLBACK.labels[k];
    return null;
  }
  function label(sid, oid) {
    var v = labelLookup(sid + '.' + oid);
    if (v == null) v = labelLookup('_.' + oid);
    return v != null ? v : String(oid).replace(/_/g, ' ');
  }
  function qText(sid, suffix) {
    return labelLookup(sid + '.' + suffix) || '';
  }

  /* ---------- tracking ---------- */
  function trackEvt(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var p = { event: name };
      if (data) Object.keys(data).forEach(function (k) { p[k] = data[k]; });
      window.dataLayer.push(p);
    } catch (e) { /* stil */ }
  }

  /* ---------- api ---------- */
  function apiFetch(path, body, timeoutMs, retries) {
    return new Promise(function (resolve, reject) {
      function attempt(left) {
        var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, timeoutMs || 5000);
        var opts = { method: body ? 'POST' : 'GET' };
        if (ctrl) opts.signal = ctrl.signal;
        if (body) {
          opts.headers = { 'Content-Type': 'application/json' };
          opts.body = JSON.stringify(body);
        }
        fetch(API + path, opts)
          .then(function (r) {
            if (!r.ok) throw new Error('http ' + r.status);
            return r.json();
          })
          .then(function (j) { clearTimeout(timer); resolve(j); })
          .catch(function (err) {
            clearTimeout(timer);
            if (left > 0) attempt(left - 1);
            else reject(err);
          });
      }
      attempt(retries || 0);
    });
  }

  function loadConfig(cb) {
    if (cfg) { cb(); return; }
    apiFetch('/api/matchmaker/config?lang=' + encodeURIComponent(LANG), null, 2000, 0)
      .then(function (data) {
        cfg = (data && data.ok && data.steps && data.steps.length) ? data : FALLBACK;
      })
      .catch(function () { cfg = FALLBACK; })
      .then(function () {
        if (!cfg) cfg = FALLBACK;
        cb();
      });
  }

  /* ---------- flow ---------- */
  function getStep(id) {
    if (!cfg || !cfg.steps) return null;
    for (var i = 0; i < cfg.steps.length; i++) {
      if (cfg.steps[i].id === id) return cfg.steps[i];
    }
    return null;
  }

  function quizPath() {
    var p = ['room'];
    if (state.answers.room === 'badkamer') p.push('wetroom');
    p.push('style', 'type');
    var tv = state.answers.type;
    var typeStep = getStep('type');
    if (tv && typeStep && typeStep.branches && typeStep.branches[tv]) {
      p = p.concat(typeStep.branches[tv]);
    }
    p.push('color', 'budget');
    return p.filter(function (id) {
      var st = getStep(id);
      if (!st) return false;
      if (st.hide_for_rooms && st.hide_for_rooms.indexOf(state.answers.room) >= 0) return false;
      return true;
    });
  }

  function pruneBranches() {
    var allowed = {};
    quizPath().forEach(function (s) { allowed[s] = 1; });
    Object.keys(STEP_KEYS).forEach(function (sid) {
      if (!allowed[sid] && state.answers[sid] != null) delete state.answers[sid];
    });
  }

  function firstUnansweredIdx() {
    var p = quizPath();
    for (var i = 0; i < p.length; i++) {
      if (state.answers[p[i]] == null) return i;
    }
    return p.length;
  }

  function isSelected(sid, oid) {
    var v = state.answers[sid];
    if (Array.isArray(v)) return v.indexOf(oid) >= 0;
    return v === oid;
  }

  /* ---------- URL-sync ---------- */
  function syncUrl() {
    var qs = [];
    Object.keys(STEP_KEYS).forEach(function (sid) {
      var v = state.answers[sid];
      if (v == null) return;
      var s = Array.isArray(v) ? v.join(',') : String(v);
      if (s) qs.push(STEP_KEYS[sid] + '=' + encodeURIComponent(s));
    });
    var url = location.pathname + (qs.length ? '?' + qs.join('&') : '') + location.hash;
    try { history.replaceState(history.state, '', url); } catch (e) { /* stil */ }
  }

  function parseUrl() {
    var raw = location.search.replace(/^\?/, '');
    if (!raw) return null;
    var out = {};
    var found = false;
    raw.split('&').forEach(function (pair) {
      var i = pair.indexOf('=');
      if (i < 1) return;
      var sid = KEY_STEPS[pair.slice(0, i)];
      if (!sid) return;
      var v;
      try { v = decodeURIComponent(pair.slice(i + 1)); } catch (e) { return; }
      var step = getStep(sid);
      if (!step) return;
      var valid = {};
      (step.options || []).forEach(function (o) { valid[o.id] = 1; });
      var vals = v.split(',').filter(function (x) { return valid[x]; });
      if (!vals.length) return;
      out[sid] = step.type === 'multi' ? vals : vals[0];
      found = true;
    });
    return found ? out : null;
  }

  /* ---------- router ---------- */
  function pushStep(i) {
    try { history.pushState({ swmm: { i: i } }, ''); } catch (e) { /* stil */ }
  }

  function gotoIdx(i) {
    var p = quizPath();
    if (i < 0) i = 0;
    if (i > p.length) i = p.length;
    state.inQuiz = true;
    if (i === p.length) renderResults();
    else renderStep(i);
  }

  function enterShell() {
    if (heroEl) heroEl.hidden = true;
    if (introEl) introEl.hidden = true;
    appEl.hidden = false;
  }

  function showIntro() {
    state.inQuiz = false;
    setSeoVisible(true);
    appEl.hidden = true;
    appEl.innerHTML = '';
    if (heroEl) heroEl.hidden = false;
    if (introEl) introEl.hidden = false;
  }

  function startQuiz(fromPop) {
    loadConfig(function () {
      if (!cfg) { trackEvt('sw_mm_error', { mm_where: 'config' }); return; }
      enterShell();
      var i = firstUnansweredIdx();
      if (!fromPop) pushStep(i);
      trackEvt('sw_mm_start', { mm_lang: LANG, mm_country: COUNTRY });
      gotoIdx(i);
    });
  }

  window.addEventListener('popstate', function (ev) {
    var st = ev.state && ev.state.swmm;
    if (st && typeof st.i === 'number') {
      if (!cfg) {
        loadConfig(function () {
          if (!cfg) return;
          enterShell();
          gotoIdx(st.i);
        });
      } else {
        enterShell();
        gotoIdx(st.i);
      }
    } else {
      showIntro();
    }
  });

  /* ---------- dom-helpers ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function cdnSize(url, w) {
    if (!url) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- iconen (1.2-stroke, gold via currentColor) ---------- */
  var ICONS = {
    woonkamer: '<path d="M5 11V8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3"/><path d="M3 13a2 2 0 0 1 4 0v1h10v-1a2 2 0 0 1 4 0v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"/><path d="M6 19v1.5M18 19v1.5"/>',
    eetkamer: '<path d="M3 9h18"/><path d="M6 9l-1 10M18 9l1 10"/><path d="M9 13h6"/>',
    slaapkamer: '<path d="M3 18v-8"/><path d="M3 12h18v6"/><path d="M3 16h18"/><path d="M6 12v-1.5A1.5 1.5 0 0 1 7.5 9h2a1.5 1.5 0 0 1 1.5 1.5V12"/>',
    kantoor: '<rect x="7" y="4" width="10" height="6"/><path d="M3 13.5h18"/><path d="M5.5 13.5V20M18.5 13.5V20"/><path d="M12 10v3.5"/>',
    kinderkamer: '<path d="M4 7.5v10M20 7.5v10"/><path d="M4 7.5h16"/><path d="M7.5 7.5V13M11 7.5V13M14.5 7.5V13"/><path d="M4 13h16"/><path d="M4 17.5c2.5 1.2 5.3 1.8 8 1.8s5.5-.6 8-1.8"/>',
    keuken: '<circle cx="11" cy="14" r="5.5"/><path d="M16.5 14H21"/><path d="M8.5 4.5c0 1-1 1.2-1 2.2s1 1.2 1 2.2M12.5 4.5c0 1-1 1.2-1 2.2s1 1.2 1 2.2"/>',
    badkamer: '<path d="M12 3.5s5.5 6.6 5.5 10.3a5.5 5.5 0 0 1-11 0C6.5 10.1 12 3.5 12 3.5Z"/>',
    vinyl: '<path d="M12 3l7 2.8v5.4c0 4.6-2.8 7.6-7 9.8-4.2-2.2-7-5.2-7-9.8V5.8Z"/><path d="m9 11.5 2 2 4-4"/>',
    vlies: '<path d="M5 3.5h9.5L19 8v12.5H5Z"/><path d="M14.5 3.5V8H19"/>',
    natuurlijk: '<path d="M4.5 19.5C4.5 10.5 10.5 4.5 19.5 4.5c0 9-6 15-15 15Z"/><path d="M4.5 19.5C8 14 11.5 10.5 16 8"/>',
    zelf: '<rect x="3.5" y="4" width="12.5" height="5"/><path d="M16 6.5h4v5h-8v3"/><path d="M12 14.5V20"/>',
    professional: '<circle cx="12" cy="7.5" r="3.2"/><path d="M5.5 20.5c.4-4 3-6.2 6.5-6.2s6.1 2.2 6.5 6.2"/>',
    geen: '<circle cx="12" cy="12" r="8.5"/><path d="M8.5 12h7"/>'
  };
  function svgIcon(name) {
    var body = ICONS[name] || ICONS.geen;
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + body + '</svg>';
  }
  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m4.5 12.5 5 5 10-11"/></svg>';
  var CLOSE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var SHARE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="6" cy="12" r="2.5"/><circle cx="17.5" cy="5.5" r="2.5"/><circle cx="17.5" cy="18.5" r="2.5"/><path d="m8.3 10.7 6.9-4M8.3 13.3l6.9 4"/></svg>';

  /* ---------- prijs-opmaak (nl-stijl) ---------- */
  function fmtMoney(v, cur) {
    var n = Number(v);
    if (!isFinite(n)) return '';
    var syms = { EUR: '€', USD: '$', GBP: '£' };
    var sym = syms[cur || 'EUR'] || (cur ? cur + ' ' : '€');
    var hasDec = Math.round(n * 100) % 100 !== 0;
    var s = hasDec ? n.toFixed(2) : String(Math.round(n));
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    s = parts.length > 1 ? parts[0] + ',' + parts[1] : parts[0];
    return sym + ' ' + s;
  }
  function unitText(u) {
    if (!u) return '';
    var x = String(u).toLowerCase();
    var key = null;
    if (x.indexOf('rol') === 0 || x.indexOf('roll') === 0) key = 'unit_rol';
    else if (x.indexOf('meter') === 0 || x.indexOf('(m1)') >= 0 || x === 'm1' || x.indexOf('metre') === 0) key = 'unit_meter';
    else if (x === 'm2' || x === 'm²' || x.indexOf('sqm') >= 0) key = 'unit_m2';
    else if (x.indexOf('paneel') === 0 || x.indexOf('panel') === 0 || x === 'set') key = 'unit_paneel';
    return (key && UI[key]) ? UI[key] : 'per ' + u;
  }

  /* ---------- stap-rendering ---------- */
  function gridClass(step) {
    if (step.visual === 'mood') return 'swmm__opts--mood';
    if (step.visual === 'pattern') return 'swmm__opts--pattern';
    if (step.visual === 'swatch') return 'swmm__opts--swatch';
    if (step.visual === 'pills') return 'swmm__opts--pills';
    var hasImg = (step.options || []).some(function (o) {
      return Object.prototype.hasOwnProperty.call(o, 'img');
    });
    return hasImg ? 'swmm__opts--wide' : 'swmm__opts--icon';
  }

  function setHint(txt) {
    var h = document.getElementById('swmm-hint');
    if (h) h.textContent = txt || '';
  }

  function refreshPressed(sid) {
    var tiles = appEl.querySelectorAll('.swmm__tile');
    for (var i = 0; i < tiles.length; i++) {
      var oid = tiles[i].getAttribute('data-opt');
      tiles[i].setAttribute('aria-pressed', isSelected(sid, oid) ? 'true' : 'false');
    }
  }

  function updateNextBtn(step) {
    var next = document.getElementById('swmm-next');
    if (!next) return;
    next.disabled = state.answers[step.id] == null;
  }

  function buildTile(step, opt) {
    var sid = step.id;
    var oid = opt.id;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'swmm__tile';
    btn.setAttribute('data-opt', oid);
    btn.setAttribute('aria-pressed', isSelected(sid, oid) ? 'true' : 'false');
    var lbl = label(sid, oid);
    var hasImgKey = Object.prototype.hasOwnProperty.call(opt, 'img');

    if (step.visual === 'swatch') {
      btn.classList.add('swmm__tile--swatch');
      var box = el('div', 'swmm__timg');
      if (oid === step.skip_option) {
        var swg = el('div', 'swmm__sw swmm__sw--geen');
        swg.innerHTML = svgIcon('geen');
        box.appendChild(swg);
      } else {
        box.appendChild(el('div', 'swmm__sw swmm__sw--' + oid));
      }
      btn.appendChild(box);
      btn.appendChild(el('span', 'swmm__tlabel', lbl));
    } else if (hasImgKey) {
      var box2 = el('div', 'swmm__timg');
      if (opt.img) {
        var im = document.createElement('img');
        im.src = cdnSize(opt.img, 480);
        im.alt = '';
        im.loading = 'lazy';
        box2.appendChild(im);
      } else {
        box2.classList.add('swmm__timg--ph');
        box2.appendChild(el('span', null, lbl));
      }
      btn.appendChild(box2);
      btn.appendChild(el('span', 'swmm__tlabel', lbl));
      var tsub = labelLookup(sid + '.' + oid + '.sub');
      if (tsub) btn.appendChild(el('span', 'swmm__tsub', tsub));
    } else if (step.visual === 'pills') {
      btn.classList.add('swmm__tile--pill');
      btn.appendChild(el('span', 'swmm__tlabel', lbl));
    } else {
      btn.classList.add('swmm__tile--icon');
      var ic = el('span', 'swmm__tico');
      ic.innerHTML = svgIcon(opt.icon || 'geen');
      btn.appendChild(ic);
      btn.appendChild(el('span', 'swmm__tlabel', lbl));
    }

    var chk = el('span', 'swmm__check');
    chk.innerHTML = CHECK_SVG;
    btn.appendChild(chk);
    btn.addEventListener('click', function () { onTile(step, opt, btn); });
    return btn;
  }

  function onTile(step, opt, btn) {
    var sid = step.id;
    var oid = opt.id;
    var skip = step.skip_option;

    if (step.type === 'multi') {
      var cur = Array.isArray(state.answers[sid]) ? state.answers[sid].slice() : [];
      var ix = cur.indexOf(oid);
      if (ix >= 0) {
        cur.splice(ix, 1);
      } else if (oid === skip) {
        cur = [oid]; /* geen-voorkeur is exclusief */
      } else {
        cur = cur.filter(function (x) { return x !== skip; });
        if (step.max && cur.length >= step.max) {
          btn.classList.remove('is-shake');
          void btn.offsetWidth;
          btn.classList.add('is-shake');
          setHint(t('max_hint'));
          return;
        }
        cur.push(oid);
      }
      if (cur.length) state.answers[sid] = cur; else delete state.answers[sid];
      pruneBranches();
      setHint('');
      refreshPressed(sid);
      updateNextBtn(step);
      syncUrl();
      requestCount();
      trackEvt(oid === skip ? 'sw_mm_skip' : 'sw_mm_step', { mm_step: sid, mm_value: cur.join(',') });
    } else {
      state.answers[sid] = oid;
      pruneBranches();
      refreshPressed(sid);
      updateNextBtn(step);
      syncUrl();
      requestCount();
      trackEvt(oid === skip ? 'sw_mm_skip' : 'sw_mm_step', { mm_step: sid, mm_value: oid });
      btn.classList.add('is-flash');
      window.setTimeout(function () { advance(); }, 250);
    }
  }

  function advance() {
    var i = state.idx + 1;
    pushStep(i);
    gotoIdx(i);
  }

  function buildBar(step) {
    var bar = el('div', 'swmm__bar');
    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'swmm__back';
    back.textContent = t('back');
    back.addEventListener('click', function () { history.back(); });
    bar.appendChild(back);
    var pill = el('span', 'swmm__pill');
    pill.id = 'swmm-pill-bar';
    pill.hidden = true;
    pill.setAttribute('aria-live', 'polite');
    bar.appendChild(pill);
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'swmm__next';
    next.id = 'swmm-next';
    next.textContent = t('next');
    next.addEventListener('click', function () {
      if (state.answers[step.id] == null) return;
      advance();
    });
    bar.appendChild(next);
    return bar;
  }

  function setSeoVisible(v) {
    document.querySelectorAll('.swmm__seo').forEach(function (n) { n.hidden = !v; });
  }

  function renderStep(i) {
    var p = quizPath();
    if (i >= p.length) { renderResults(); return; }
    var sid = p[i];
    var step = getStep(sid);
    if (!step) { renderResults(); return; }
    /* Kevin r12: vraag overslaan als de selectie al scherp genoeg is */
    var goingBack = i < state.idx;
    if (step.skip_if_count_lt && state.answers[sid] == null &&
        typeof state.lastCount === 'number' && state.lastCount < step.skip_if_count_lt) {
      renderStep(goingBack ? i - 1 : i + 1);
      return;
    }
    state.idx = i;
    setSeoVisible(false);
    appEl.innerHTML = '';
    appEl.hidden = false;

    var prog = el('div', 'swmm__prog');
    var fill = el('div', 'swmm__progfill');
    fill.style.width = Math.round(((i + 1) / (p.length + 1)) * 100) + '%';
    prog.appendChild(fill);
    appEl.appendChild(prog);

    var meta = el('div', 'swmm__progmeta');
    meta.appendChild(el('span', 'swmm__stepn', t('step_of', { x: i + 1, y: p.length })));
    var pill = el('span', 'swmm__pill');
    pill.id = 'swmm-pill-top';
    pill.hidden = true;
    pill.setAttribute('aria-live', 'polite');
    meta.appendChild(pill);
    appEl.appendChild(meta);

    var wrap = el('div', 'swmm__fade');
    var h = el('h2', 'swmm__q', qText(sid, 'q'));
    h.id = 'swmm-q';
    h.setAttribute('tabindex', '-1');
    wrap.appendChild(h);
    var sub = qText(sid, 'sub');
    if (sub) wrap.appendChild(el('p', 'swmm__qsub', sub));
    var hint = el('p', 'swmm__hint', '');
    hint.id = 'swmm-hint';
    wrap.appendChild(hint);

    var grid = el('div', 'swmm__opts ' + gridClass(step));
    grid.setAttribute('role', 'group');
    grid.setAttribute('aria-label', qText(sid, 'q'));
    var opts = step.options || [];
    /* Kevin r12: werelden-stap volgt de gekozen stijl(en) */
    if (sid === 'theme' && cfg && cfg.style_theme_map) {
      var chosen = Array.isArray(state.answers.style) ? state.answers.style : [];
      var allow = {}, any = false;
      chosen.forEach(function (st) {
        (cfg.style_theme_map[st] || []).forEach(function (th) { allow[th] = 1; any = true; });
      });
      if (any) {
        var filtered = opts.filter(function (o) { return allow[o.id] || o.id === step.skip_option; });
        if (filtered.length > 1) opts = filtered;
      }
    }
    /* Kevin r13: behang op maat bestaat amper onder €70/m² — lagere budgetten weg + melding */
    if (step.min_by_type && state.answers.type && step.min_by_type[state.answers.type]) {
      var minId = step.min_by_type[state.answers.type];
      var seen = false;
      opts = opts.filter(function (o) {
        if (o.id === minId) seen = true;
        return seen || o.id === step.skip_option;
      });
      var note = qText(sid, 'mural_note');
      if (note) wrap.appendChild(el('p', 'swmm__qsub swmm__note', note));
    }
    opts.forEach(function (opt) { grid.appendChild(buildTile(step, opt)); });
    wrap.appendChild(grid);
    appEl.appendChild(wrap);

    appEl.appendChild(buildBar(step));
    updateNextBtn(step);
    requestCount();
    try { h.focus(); } catch (e) { /* stil */ }
  }

  /* ---------- live-teller ---------- */
  var countTimer = null;
  var countSeq = 0;
  function requestCount() {
    if (!state.inQuiz) return;
    if (countTimer) clearTimeout(countTimer);
    countTimer = setTimeout(doCount, 250);
  }
  function doCount() {
    var seq = ++countSeq;
    if (!Object.keys(state.answers).length) { setPill(null); return; }
    apiFetch('/api/matchmaker/count', { answers: state.answers }, 1500, 0)
      .then(function (j) {
        if (seq !== countSeq) return;
        if (!j || j.ok === false || typeof j.count !== 'number') { setPill(null); return; }
        state.lastCount = j.count;
        setPill(j.count);
      })
      .catch(function () { if (seq === countSeq) setPill(null); });
  }
  function setPill(n) {
    ['swmm-pill-top', 'swmm-pill-bar'].forEach(function (id) {
      var node = document.getElementById(id);
      if (!node) return;
      if (n == null) { node.hidden = true; return; }
      node.hidden = false;
      if (n < 80) {
        node.classList.add('is-sharp');
        node.textContent = t('count_sharp', { n: n });
      } else {
        node.classList.remove('is-sharp');
        node.textContent = t('count_many', { n: n });
      }
    });
  }

  /* ---------- resultaten ---------- */
  var resSeq = 0;

  function skeletonCard() {
    var sk = el('div', 'swmm__sk');
    sk.appendChild(el('div', 'swmm__sk-img'));
    sk.appendChild(el('div', 'swmm__sk-l1'));
    sk.appendChild(el('div', 'swmm__sk-l2'));
    return sk;
  }

  function collectionList() {
    var ul = document.createElement('ul');
    var cols = [
      ['col_jungle', '/collections/jungle-behang'],
      ['col_geometrisch', '/collections/geometrisch-behang'],
      ['col_bloemen', '/collections/bloemen-behang'],
      ['col_effen', '/collections/effen-behang'],
      ['col_panorama', '/collections/panorama-behang']
    ];
    cols.forEach(function (c) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = ROOT_PATH + c[1];
      a.textContent = t(c[0]);
      li.appendChild(a);
      ul.appendChild(li);
    });
    return ul;
  }

  function buildPicker(sid) {
    /* Kevin r16: keuzes wijzigen zonder opnieuw te beginnen */
    var step = getStep(sid);
    if (!step) return null;
    var box = el('div', 'swmm__picker');
    var head = el('div', 'swmm__picker-h', qText(sid, 'q'));
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'swmm__picker-x';
    close.innerHTML = CLOSE_SVG;
    close.setAttribute('aria-label', t('back'));
    close.addEventListener('click', function () { state.pickerSid = null; renderResults(); });
    head.appendChild(close);
    box.appendChild(head);
    var row = el('div', 'swmm__picker-opts');
    var opts = (step.options || []).slice();
    if (step.min_by_type && state.answers.type && step.min_by_type[state.answers.type]) {
      var minId = step.min_by_type[state.answers.type];
      var seen = false;
      opts = opts.filter(function (o) {
        if (o.id === minId) seen = true;
        return seen || o.id === step.skip_option;
      });
    }
    opts.forEach(function (opt) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'swmm__picker-opt';
      var cur = state.answers[sid];
      var on = Array.isArray(cur) ? cur.indexOf(opt.id) >= 0 : cur === opt.id;
      if (on) b.classList.add('is-on');
      b.textContent = label(sid, opt.id);
      b.addEventListener('click', function () {
        if (step.type === 'multi') {
          var arr = Array.isArray(state.answers[sid]) ? state.answers[sid].slice() : [];
          if (opt.id === step.skip_option) {
            arr = [opt.id];
          } else {
            var ix = arr.indexOf(opt.id);
            arr = arr.filter(function (x) { return x !== step.skip_option; });
            if (ix >= 0) arr.splice(arr.indexOf(opt.id), 1);
            else if (!(step.max && arr.length >= step.max)) arr.push(opt.id);
          }
          if (arr.length) state.answers[sid] = arr; else delete state.answers[sid];
        } else {
          if (opt.id === step.skip_option) delete state.answers[sid];
          else state.answers[sid] = opt.id;
          state.pickerSid = null;
        }
        pruneBranches();
        syncUrl();
        trackEvt('sw_mm_chip_edit', { mm_step: sid, mm_value: opt.id });
        renderResults();
      });
      row.appendChild(b);
    });
    box.appendChild(row);
    return box;
  }

  function buildChips() {
    var bar = el('div', 'swmm__chips');
    bar.appendChild(el('span', 'swmm__chips-h', t('chips_h')));
    quizPath().forEach(function (sid) {
      var v = state.answers[sid];
      if (v == null) return;
      (Array.isArray(v) ? v : [v]).forEach(function (oid) {
        if (oid === 'geen_voorkeur') return;
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'swmm__chip';
        chip.appendChild(document.createTextNode(label(sid, oid)));
        var x = el('span');
        x.innerHTML = CLOSE_SVG;
        chip.appendChild(x);
        chip.addEventListener('click', function () {
          state.pickerSid = (state.pickerSid === sid ? null : sid);
          renderResults();
        });
        x.addEventListener('click', function (ev) { ev.stopPropagation(); removeAnswer(sid, oid); });
        bar.appendChild(chip);
      });
    });
    var re = document.createElement('button');
    re.type = 'button';
    re.className = 'swmm__restart';
    re.textContent = t('restart');
    re.addEventListener('click', restart);
    bar.appendChild(re);
    return bar;
  }

  function removeAnswer(sid, oid) {
    var v = state.answers[sid];
    if (Array.isArray(v)) {
      v = v.filter(function (x) { return x !== oid; });
      if (v.length) state.answers[sid] = v; else delete state.answers[sid];
    } else if (v === oid) {
      delete state.answers[sid];
    }
    if (sid === 'type') pruneBranches();
    trackEvt('sw_mm_chip_remove', { mm_step: sid, mm_value: oid });
    syncUrl();
    renderResults();
  }

  function restart() {
    state.answers = {};
    state.results = null;
    syncUrl();
    pushStep(0);
    gotoIdx(0);
  }

  function renderResults() {
    var liveGrid = document.getElementById('swmm-grid');
    if (liveGrid && state.inQuiz && state.idx >= quizPath().length) {
      /* al op de resultatenpagina: alleen chips/picker bijwerken en grid zacht verversen */
      state.idx = quizPath().length;
      var oldChips = appEl.querySelector('.swmm__chips');
      var newChips = buildChips();
      if (oldChips) { appEl.replaceChild(newChips, oldChips); } else { appEl.insertBefore(newChips, appEl.firstChild); }
      var oldPick = appEl.querySelector('.swmm__picker');
      if (oldPick) oldPick.remove();
      if (state.pickerSid) {
        var pk = buildPicker(state.pickerSid);
        if (pk) newChips.parentNode.insertBefore(pk, newChips.nextSibling);
      }
      liveGrid.style.opacity = '.45';
      fetchResults();
      return;
    }
    state.idx = quizPath().length;
    state.inQuiz = true;
    setSeoVisible(false);
    appEl.innerHTML = '';
    appEl.hidden = false;
    appEl.appendChild(buildChips());
    if (state.pickerSid) {
      var pk = buildPicker(state.pickerSid);
      if (pk) appEl.appendChild(pk);
    }
    var h = el('h2', 'swmm__res-h', t('results_h'));
    h.id = 'swmm-q';
    h.setAttribute('tabindex', '-1');
    appEl.appendChild(h);
    var sub = el('p', 'swmm__res-sub', t('loading'));
    sub.id = 'swmm-res-sub';
    appEl.appendChild(sub);
    var grid = el('div', 'swmm__grid');
    grid.id = 'swmm-grid';
    for (var i = 0; i < 12; i++) grid.appendChild(skeletonCard());
    appEl.appendChild(grid);
    try { h.focus(); } catch (e) { /* stil */ }
    fetchResults();
  }

  function fetchResults() {
    var seq = ++resSeq;
    apiFetch('/api/matchmaker/results', { answers: state.answers, lang: LANG, session_id: state.sessionId }, 8000, 1)
      .then(function (j) {
        if (seq !== resSeq) return;
        if (!j || j.ok === false || !Array.isArray(j.results)) { showResultsError(); return; }
        state.results = j;
        paintResults(j);
      })
      .catch(function () { if (seq === resSeq) showResultsError(); });
  }

  function showResultsError() {
    trackEvt('sw_mm_error', { mm_where: 'results' });
    var grid = document.getElementById('swmm-grid');
    var sub = document.getElementById('swmm-res-sub');
    if (sub) sub.textContent = '';
    if (!grid) return;
    grid.innerHTML = '';
    grid.style.opacity = '';
    var box = el('div', 'swmm__err');
    box.style.gridColumn = '1/-1';
    box.appendChild(el('p', null, t('err_results')));
    box.appendChild(collectionList());
    var retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'swmm__retry';
    retry.textContent = t('retry');
    retry.addEventListener('click', renderResults);
    box.appendChild(retry);
    grid.appendChild(box);
  }

  function productCard(item) {
    /* Kevin r16: exact de collectiepagina-kaart (theme-classes grid-view-item) */
    var card = el('div', 'grid-view-item style1 swmm-gitem');
    var gv = el('div', 'gview-img');
    var a = document.createElement('a');
    a.className = 'gimg-link';
    a.href = (item.url || '#') + (item.variant_id ? '?variant=' + item.variant_id : '');
    a.title = item.title || '';
    a.addEventListener('click', function () { trackEvt('sw_mm_result_click', { mm_product: item.product_id }); });
    var img = el('div', 'gitem-img lazyloaded primary swmm-gimg');
    if (item.image) {
      var u1 = cdnSize(item.image, 700);
      img.style.backgroundImage = "url('" + u1 + "')";
      (function (node, orig, sized) {
        var probe = new Image();
        probe.onerror = function () { node.style.backgroundImage = "url('" + orig + "')"; };
        probe.src = sized;
      })(img, item.image, u1);
    }
    a.appendChild(img);
    if (item.hover_image) {
      /* lazy: pas laden bij eerste hover; pas tonen als het beeld ECHT geladen is */
      (function (wrap, anchor, hurl) {
        var busy = false;
        wrap.addEventListener('mouseenter', function () {
          if (busy) return;
          busy = true;
          var probe = new Image();
          probe.onload = function () {
            var hov = el('div', 'gitem-img hover swmm-gimg-h');
            hov.style.backgroundImage = "url('" + hurl + "')";
            anchor.appendChild(hov);
          };
          probe.src = hurl;
        });
      })(gv, a, cdnSize(item.hover_image, 700));
    }
    gv.appendChild(a);
    if (item.match_tier !== 'exact') {
      gv.appendChild(el('span', 'swmm__badge swmm__badge--near', t('badge_near')));
    }
    card.appendChild(gv);
    var det = el('div', 'details');
    if (item.vendor) {
      var ven = el('div', 'grid-view-item__vendor');
      ven.appendChild(el('a', null, item.vendor));
      det.appendChild(ven);
    }
    var ti = document.createElement('a');
    ti.className = 'grid-view-item__title';
    ti.href = (item.url || '#') + (item.variant_id ? '?variant=' + item.variant_id : '');
    ti.textContent = item.title || '';
    ti.addEventListener('click', function () { trackEvt('sw_mm_result_click', { mm_product: item.product_id }); });
    det.appendChild(ti);
    if (item.price_from != null) {
      var pw = el('div', 'priceWraper fl f-aic f-jcc f-wrap');
      var pr = el('span', 'pr_price');
      var amt = el('span', 'pr_price_amount');
      amt.style.fontSize = '1.06em';
      var m1 = el('span', 'money', fmtMoney(Math.round(item.price_from), item.currency));
      amt.appendChild(m1);
      pr.appendChild(amt);
      pr.appendChild(document.createTextNode(' '));
      var suf = el('span', 'price-unit-suffix');
      suf.style.fontWeight = '400';
      suf.style.fontSize = '0.92em';
      suf.appendChild(el('span', 'price-unit-text', unitText(item.price_unit)));
      var showM2 = item.price_m2 != null && item.price_unit && String(item.price_unit).toLowerCase() !== 'm2';
      if (showM2) {
        var mp = el('span', 'price-m2-part');
        mp.appendChild(el('span', 'price-m2-sep', ' | '));
        mp.appendChild(el('span', 'money', fmtMoney(Math.round(item.price_m2), item.currency)));
        mp.appendChild(el('span', 'price-m2-per', ' per'));
        mp.appendChild(document.createTextNode(' m\u00b2'));
        suf.appendChild(mp);
      }
      pr.appendChild(suf);
      pw.appendChild(pr);
      det.appendChild(pw);
    }
    if (item.swatches && item.swatches.length && (item.swatches.length > 1 || item.variant_id)) {
      var ul = document.createElement('ul');
      ul.className = 'gridSwatches fl f-aic f-jcc';
      item.swatches.forEach(function (sv) {
        var li = document.createElement('li');
        li.className = 'swatch medium clrswt lazyloaded';
        li.title = sv.k || '';
        li.setAttribute('role', 'link');
        if (sv.img) li.style.cssText = 'background-image:url(' + cdnSize(sv.img, 140) + ');background-position:50% 50%;background-repeat:no-repeat;background-size:cover;';
        li.addEventListener('click', function () {
          trackEvt('sw_mm_swatch_click', { mm_product: item.product_id });
          window.location.href = (item.url || '#') + (sv.vid ? '?variant=' + sv.vid : '');
        });
        ul.appendChild(li);
      });
      if (item.swatch_more > 0) {
        var more = document.createElement('li');
        more.className = 'swmm-swmore';
        more.textContent = item.swatch_more + '+';
        ul.appendChild(more);
      }
      det.appendChild(ul);
    }
    card.appendChild(det);
    return card;
  }

  function paintResults(j) {
    var res = j.results || [];
    var sub = document.getElementById('swmm-res-sub');
    var grid = document.getElementById('swmm-grid');
    if (!grid) return;
    appEl.querySelectorAll('.swmm__relax, .swmm__res-foot').forEach(function (n) { n.remove(); });
    grid.innerHTML = '';
    grid.style.opacity = '';

    if (!res.length) {
      if (sub) sub.textContent = t('none_sub');
      var eb = el('div', 'swmm__err');
      eb.style.gridColumn = '1/-1';
      eb.appendChild(el('p', null, t('none_h')));
      eb.appendChild(collectionList());
      grid.appendChild(eb);
      trackEvt('sw_mm_complete', { mm_results: 0 });
      return;
    }

    if (sub) sub.textContent = t('results_sub', { n: res.length });
    if (j.near > 0) {
      grid.parentNode.insertBefore(el('p', 'swmm__relax', t('relaxed')), grid);
    }

    var cut = (window.matchMedia && window.matchMedia('(max-width:760px)').matches) ? 6 : 12;
    res.forEach(function (item, ix) {
      grid.appendChild(productCard(item));
      if (EMAIL_ON && ix === cut - 1) grid.appendChild(emailBlock());
    });
    if (EMAIL_ON && res.length < cut) grid.appendChild(emailBlock());

    var foot = el('div', 'swmm__res-foot');
    if (j.collection_link && j.collection_link.url) {
      var va = document.createElement('a');
      va.className = 'swmm__viewall';
      va.href = j.collection_link.url;
      va.textContent = t('view_all', { theme: j.collection_link.theme || '' });
      foot.appendChild(va);
    }
    var sh = document.createElement('button');
    sh.type = 'button';
    sh.className = 'swmm__share';
    sh.innerHTML = SHARE_SVG;
    sh.appendChild(document.createTextNode(t('share')));
    sh.addEventListener('click', shareSelection);
    foot.appendChild(sh);
    grid.parentNode.appendChild(foot);

    trackEvt('sw_mm_complete', { mm_results: res.length, mm_exact: j.exact || 0 });
  }

  /* ---------- e-mail-blok ---------- */
  function emailBlock() {
    var box = el('div', 'swmm__email');
    box.appendChild(el('h3', null, t('email_h')));
    box.appendChild(el('p', 'swmm__email-sub', t('email_sub')));
    var form = document.createElement('form');
    form.noValidate = true;
    var row = el('div', 'swmm__email-row');
    var inp = document.createElement('input');
    inp.type = 'email';
    inp.name = 'email';
    inp.placeholder = t('email_ph');
    inp.autocomplete = 'email';
    inp.setAttribute('aria-label', t('email_ph'));
    row.appendChild(inp);
    var btn = document.createElement('button');
    btn.type = 'submit';
    btn.className = 'swmm__email-btn';
    btn.textContent = t('email_btn');
    row.appendChild(btn);
    form.appendChild(row);
    var lab = document.createElement('label');
    lab.className = 'swmm__optin';
    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.name = 'newsletter_optin';
    lab.appendChild(cb);
    lab.appendChild(document.createTextNode(' ' + t('email_nl')));
    form.appendChild(lab);
    var hp = el('div', 'swmm__hp');
    var hpi = document.createElement('input');
    hpi.type = 'text';
    hpi.name = 'website_url';
    hpi.tabIndex = -1;
    hpi.autocomplete = 'off';
    hpi.setAttribute('aria-hidden', 'true');
    hp.appendChild(hpi);
    form.appendChild(hp);
    var msg = el('p', 'swmm__email-msg', '');
    form.appendChild(msg);
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var em = (inp.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) {
        msg.className = 'swmm__email-msg is-err';
        msg.textContent = t('email_invalid');
        return;
      }
      if ((hpi.value || '').trim()) {
        /* honeypot gevuld: doe alsof, verstuur niets */
        msg.className = 'swmm__email-msg is-ok';
        msg.textContent = t('email_ok');
        return;
      }
      btn.disabled = true;
      var ids = ((state.results && state.results.results) || []).map(function (r) { return r.product_id; });
      apiFetch('/api/matchmaker/email', {
        email: em,
        newsletter_optin: !!cb.checked,
        answers: state.answers,
        product_ids: ids,
        share_url: location.href,
        lang: LANG
      }, 8000, 0)
        .then(function (jr) {
          if (jr && jr.ok !== false) {
            msg.className = 'swmm__email-msg is-ok';
            msg.textContent = t('email_ok');
            trackEvt('sw_mm_email_submit', { mm_optin: !!cb.checked });
          } else {
            msg.className = 'swmm__email-msg is-err';
            msg.textContent = t('email_err');
            btn.disabled = false;
          }
        })
        .catch(function () {
          msg.className = 'swmm__email-msg is-err';
          msg.textContent = t('email_err');
          btn.disabled = false;
        });
    });
    box.appendChild(form);
    return box;
  }

  /* ---------- delen + toast ---------- */
  var toastEl = null;
  var toastTimer = null;
  function toast(txt) {
    if (!toastEl) {
      toastEl = el('div', 'swmm__toast');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = txt;
    toastEl.classList.add('is-on');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }
  function legacyCopy(url) {
    var ta = document.createElement('textarea');
    ta.value = url;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); toast(t('copied')); } catch (e) { /* stil */ }
    document.body.removeChild(ta);
  }
  function shareSelection() {
    var url = location.href;
    trackEvt('sw_mm_share', {});
    var btn = document.querySelector('.swmm__share');
    function confirmOnButton() {
      toast(t('copied'));
      if (!btn) return;
      if (!btn.dataset.lbl) btn.dataset.lbl = btn.textContent;
      btn.classList.add('is-done');
      btn.textContent = t('copied');
      setTimeout(function () {
        btn.classList.remove('is-done');
        btn.textContent = btn.dataset.lbl;
      }, 2800);
    }
    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(function () { /* geannuleerd */ });
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(confirmOnButton, function () { legacyCopy(url); confirmOnButton(); });
    } else {
      legacyCopy(url);
      confirmOnButton();
    }
  }

  /* ---------- init ---------- */
  var startBtn = document.getElementById('swmm-start');
  if (startBtn) {
    startBtn.addEventListener('click', function () { startQuiz(false); });
  }

  /* deep-link: antwoorden in de URL → quiz direct hervatten (corrupte params stil negeren) */
  if (location.search && location.search.length > 1) {
    loadConfig(function () {
      if (!cfg) return;
      var pre = parseUrl();
      if (pre) {
        state.answers = pre;
        pruneBranches();
        startQuiz(false);
      }
    });
  }

  /* één debug-object, geen console-spam */
  window.SWMM = {
    version: 1,
    get state() { return state; },
    get config() { return cfg; }
  };
})();
